import styles from './PageHeader.module.css';

// Title + optional kicker/subtitle on the left, actions on the right.
// Kicker renders an uppercase bracket tag above the title.
export default function PageHeader({ kicker, title, subtitle, actions }) {
  return (
    <div className={styles.header}>
      <div>
        {kicker && <div className={styles.kicker}>{kicker}</div>}
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
